import React from 'react';
import { IMaxFileSizeMB } from '../formImageUploaderNewState/formImageUploaderNewContext';
import { Badge } from 'components/Badge';
import Text from 'components/Text/Text';

interface IProps {
	titleTranslationKey: string;
	subtitleTranslationKey: string;
	maxFileSizeMB: IMaxFileSizeMB;
}

export const UploaderHeader: React.FC<IProps> = ({ titleTranslationKey, subtitleTranslationKey, maxFileSizeMB }) => (
	<div className="w-full flex flex-col items-start">
		<div className="flex gap-2 items-center">
			<Text
				className="whitespace-nowrap"
				translationNameSpace="form"
				translationKey={titleTranslationKey}
				size="l"
				weight="bold"
			/>
			<Badge color="purple">
				<Text translationNameSpace="form" translationKey="imageTabLabel" asFragment={true} />
			</Badge>
			{!!maxFileSizeMB.gif && (
				<Badge color="purple">
					<Text translationNameSpace="form" translationKey="gifTabLabel" asFragment={true} />
				</Badge>
			)}
			{!!maxFileSizeMB.video && (
				<Badge color="purple">
					<Text translationNameSpace="form" translationKey="videoTabLabel" asFragment={true} />
				</Badge>
			)}
		</div>
		<Text
			className="whitespace-nowrap"
			translationNameSpace="form"
			translationKey={subtitleTranslationKey}
			size="m"
		/>
	</div>
);
